// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__z-fTO","badgeImage":"Badge_badgeImage__uPZAg","starScaling":"Badge_starScaling__q9-OU"};